import {get, type Writable, writable} from "svelte/store";
import {keywords} from "./SuggestionStore";
import {visualSearches} from "./HistoryStore";
import {indexStore} from "./IndexStore";
import {suggestType} from "./Derived";
import {SuggestType} from "../constants/suggestType";

/**
 *
 */
export class HybridStore {
  maxTrendingQueryItems: Writable<number> = writable(10);


  private historySuggestions: number = 0;
  private trendingSuggestions: number = 0;

  constructor() {
    keywords.subscribe(value => {
        this.trendingSuggestions = value.length
        this.updateMaxIndex()
    });

    visualSearches.subscribe(value => {
        this.historySuggestions = value.length
        this.updateMaxIndex()
    });

    suggestType.subscribe(value => {
        if (value === SuggestType.HYBRID) {
           this.maxTrendingQueryItems.set(5);
        } else {
           this.maxTrendingQueryItems.set(10);
        }
        this.updateMaxIndex()
    });
  }

  updateMaxIndex() {
    let maxLength = this.historySuggestions + Math.min(this.trendingSuggestions, get(this.maxTrendingQueryItems));
    indexStore.updateMaxIndex(maxLength);
  }
}

export const hybridStore = new HybridStore();
export const maxTrendingQueryItems = hybridStore.maxTrendingQueryItems;
